<div class="mb-3">
  <div class="d-flex align-items-center gap-2 mb-2">
    <label class="form-label">Phone Number </label>
    @if (required()) {
      <span class="text-danger">*</span>
    }
    <span
      (click)="addPhoneField()"
      role="button"
      [ngClass]="!canAddMore() ? 'pe-none text-muted' : 'text-primary'"
      [ngbTooltip]="'Add Number'"
      placement="top"
      ><span class="bi bi-plus-circle"></span
    ></span>
  </div>

  @for (phoneGroup of visiblePhones; track $index; let i = $index) {
    <div class="row gy-2" [ngClass]="i > 0 ? 'mt-3' : ''">
      <div class="col-md-4">
        <ng-select
          [formControl]="getFormControl(i, 'type')"
          (change)="onTypeChange(i, $event)"
          placeholder="Select Type..."
          [clearable]="false"
        >
          @for (type of getAvailableTypes(i); track type) {
            <ng-option [value]="type">
              {{ type | titlecase }}
            </ng-option>
          }
        </ng-select>
      </div>
      <div class="col-md">
        <input
          class="form-control {{
            getFormControl(i, 'phoneNumber').invalid && getFormControl(i, 'phoneNumber').touched ? 'is-invalid' : ''
          }} {{ getFormControl(i, 'phoneNumber').valid && getFormControl(i, 'phoneNumber').touched ? 'is-valid' : '' }}"
          type="text"
          [formControl]="getFormControl(i, 'phoneNumber')"
          [placeholder]="'Enter ' + (getFormControl(i, 'type').value | titlecase) + ' Number'"
        />
      </div>
      @if (i > 0) {
        <div class="col-md-auto d-flex align-items-center">
          <span
            (click)="removePhoneField(i)"
            class="bi bi-trash text-danger p-2 fs-18"
            role="button"
            [ngbTooltip]="'Delete'"
            placement="top"
          ></span>
        </div>
      }
    </div>
    <div class="row">
      <div class="col">
        @if (getFormControl(i, 'phoneNumber').touched && getFormControl(i, 'phoneNumber').errors) {
          @if (getFormControl(i, 'phoneNumber').hasError('required')) {
            <span class="text-danger fs-14">
              <i class="bi bi-exclamation-circle me-1"></i>
              <span>{{ getFormControl(i, 'type').value | titlecase }} number is required</span>
            </span>
          } @else if (getFormControl(i, 'phoneNumber').hasError('whitespace')) {
            <span class="text-danger fs-14">
              <i class="bi bi-exclamation-circle me-1"></i>
              <span>Spaces are not allowed in phone numbers</span>
            </span>
          }
        }
      </div>
    </div>
  }
</div>
